export const countries = {
  gp: {
    description:
      "Het vlindereiland biedt een rijke Creoolse cultuur, prachtige stranden en de Soufrière-vulkaan.",
    landmarks: [
      "Soufrière-vulkaan",
      "Grande Anse strand",
      "Carbet-watervallen",
    ],
    gastronomy: "Kabeljauwbeignets, kip colombo, bokit.",
  },
  mq: {
    description:
      "Het betoverende bloemeneiland, wereldberoemd om de Mount Pelée en pure rum.",
    landmarks: ["Mount Pelée", "Balata Tuin", "Diamant Rots"],
    gastronomy: "Gerookte kip, Creoolse bloedworst.",
  },
  gf: {
    description:
      "De toegangspoort van Europa tot de ruimte en de amazonebos-biodiversiteit.",
    landmarks: ["Guiana Space Centre", "Salvation Islands", "Kaw-moerassen"],
    gastronomy: "Awara-soep, wildfricassee.",
  },
  re: {
    description:
      "Een vulkanisch juweel in de Indische Oceaan met turquoise lagunes.",
    landmarks: ["Piton de la Fournaise", "Mafate Cirque", "Piton des Neiges"],
    gastronomy: "Rougail worst, kipkerrie, samosa's.",
  },
  yt: {
    description:
      "Het parfumeiland omringd door een gigantische lagune met majestueuze zeeschildpadden.",
    landmarks: ["Mayotte Lagune", "Mount Choungui", "N'Gouja Strand"],
    gastronomy: "Zeboe-spiesjes, Mataba, Pilao-rijst.",
  },
  pf: {
    description:
      "Het aardse paradijs in de Stille Oceaan, bezaaid met waterbungalows en koraalriffen.",
    landmarks: ["Bora Bora Lagune", "Mount Otemanu", "Cook's Bay"],
    gastronomy: "Rauwe vis in kokosmelk, poe dessert.",
  },
  nc: {
    description:
      "Een land van contrasten, met 's werelds grootste gesloten lagune en de Kanak-cultuur.",
    landmarks: ["Amédée-vuurtoren", "Heart of Voh", "Oro Bay"],
    gastronomy: "Traditionele Bougna, hertensalade.",
  },
  ic: {
    description:
      "Een archipel in de eeuwige lente, gevormd door indrukwekkende vulkaanlandschappen.",
    landmarks: ["Teide Nationaal Park", "Maspalomas-duinen", "Timanfaya"],
    gastronomy: "Papas arrugadas, mojo-saus.",
  },
  ptm: {
    description:
      "Het eiland van de eeuwige lente dat dramatisch in de Atlantische Oceaan wegzakt.",
    landmarks: ["Pico do Arieiro", "Cabo Girão", "Levadas-paden"],
    gastronomy: "Espetada, bolo do caco-brood, zwarte degenvis.",
  },
  pta: {
    description:
      "Een ongerept zeereservaat waar vulkanische kraters prachtige tweelingmeren vormen.",
    landmarks: ["Sete Cidades-meren", "Pico", "Furnas-warmwaterbronnen"],
    gastronomy: "Cozido das Furnas (stoofschotel), São Jorge-kaas.",
  },
  aw: {
    description:
      "Verkoelende passaatwinden waaien over lange witte zandstranden op dit eiland.",
    landmarks: ["Arikok Nationaal Park", "Eagle Beach", "California-vuurtoren"],
    gastronomy: "Keshi Yena, pastechi, geitenstoofpot.",
  },
  cw: {
    description:
      "Beroemd om zijn verborgen kristalheldere baaien en pastelkleurige architectuur.",
    landmarks: ["Koningin Emmabrug", "Playa Porto Mari", "Christoffel Park"],
    gastronomy: "Karni stoba-stoof, pompoenpannenkoeken.",
  },
  sx: {
    description:
      "The Friendly Island, charmant door vliegtuigen op het strand en een mix van eetculturen.",
    landmarks: ["Maho Beach", "Pic Paradis", "Orient Bay"],
    gastronomy: "BBQ-ribbetjes, journey cakes, gevulde krab.",
  },
  bm: {
    description:
      "Een elegante mystieke archipel omzoomd door prachtige, roze gekleurde mysterieuze stranden.",
    landmarks: ["Horseshoe Bay Beach", "Kristalgrotten", "Gibbs Hill"],
    gastronomy: "Bermuda Vissoep, hoppin' john.",
  },
  ky: {
    description:
      "Het droom-paradijs van alle diepzeeduikers om te spelen en zwemmen in zee met majestueuze roggen.",
    landmarks: ["Stingray City", "Seven Mile Beach", "Botanische Tuinen"],
    gastronomy: "Rundvlees in Cayman-stijl, schelpdierbeignets.",
  },

  de: {
    description:
      "Duitsland combineert stedelijke moderniteit met de romantiek van zijn kastelen en het Zwarte Woud. Bekend om zijn dynamiek en rijke geschiedenis.",
    gastronomy: "Braadworst, krakeling, zuurkool, bier.",
    landmarks: [
      "Brandenburger Tor, Berlijn",
      "Kasteel Neuschwanstein",
      "Dom van Keulen",
      "Marienplatz, München",
    ],
  },
  ch: {
    description:
      "Zwitserland is een alpenparadijs met diepblauwe meren, middeleeuwse forten en duizelingwekkende bergen, perfect voor zowel natuur- als comfortliefhebbers.",
    gastronomy: "Kaasfondue, raclette, Zwitserse chocolade, rösti.",
    landmarks: [
      "Matterhorn",
      "Meer van Genève",
      "Chillon-kasteel",
      "Jungfraujoch",
    ],
  },
  be: {
    description:
      "België, in het hart van Europa, is wereldberoemd vanwege zijn betoverende middeleeuwse stadjes, de Europese diplomatie, zijn chocolade en bier.",
    gastronomy: "Wafels, friet, mosselen, pralines, trappistenbieren.",
    landmarks: [
      "Grote Markt van Brussel",
      "Belfort van Brugge",
      "Atomium",
      "Kasteel Gravensteen",
    ],
  },
  hr: {
    description:
      "Kroatië biedt meer dan duizend eilanden langs de Adriatische Zee, bezaaid met Romeinse architectonische juweeltjes en weelderige nationale parken.",
    gastronomy: "Ćevapi, octopussalade, peka, kazen van het eiland Pag.",
    landmarks: [
      "Muren van Dubrovnik",
      "Nationaal park Plitvicemeren",
      "Paleis van Diocletianus",
    ],
  },
  ee: {
    description:
      "Estland is een digitale pioniersnatie met uitgestrekte oerbossen en een intacte middeleeuwse hoofdstad met uitzicht op de Oostzee.",
    gastronomy:
      "Verivorst (bloedworst), zwart brood, sprot, ambachtelijk bier.",
    landmarks: [
      "Oude binnenstad van Tallinn",
      "Lahemaa Nationaal Park",
      "Herman kasteel",
    ],
  },
  fi: {
    description:
      "Finland, het land van de duizend meren, staat bekend om zijn glinsterende wildernis, het noorderlicht in Lapland en zijn vitale saunacultuur.",
    gastronomy:
      "Gerookte zalm, rendiervlees, roggebrood, Karelische pasteitjes.",
    landmarks: ["Suomenlinna", "Kerstman dorp", "Nuuksio Nationaal Park"],
  },
  bg: {
    description:
      "Bulgarije is een Balkan-mozaïek dat gouden kusten van de Zwarte Zee, bergachtige gebieden en een ongelooflijk Thracisch erfgoed combineert.",
    gastronomy: "Banitsa, Shopska-salade, tarator, Bulgaarse moussaka.",
    landmarks: ["Rilaklooster", "Alexander Nevski-kathedraal", "Zonnig strand"],
  },
  hu: {
    description:
      "Hongarije wordt prachtig doorsneden door de Donau, vol met spectaculaire thermale baden, historische wijngaarden en het majestueuze parlement.",
    gastronomy: "Goulash, Lángos, Kip Paprikash, Tokaji-wijn.",
    landmarks: [
      "Parlement van Boedapest",
      "Thermaal bad van Széchenyi",
      "Het Boeda-kasteel",
      "Balatonmeer",
    ],
  },
  cz: {
    description:
      "Tsjechië fascineert met zijn steden met honderd torenspitsen, eeuwenoude brouwerijen en sprookjesachtige kastelen in het hart van Midden-Europa.",
    gastronomy: "Goulash, Trdelník, Vepřo knedlo zelo, Pilsner.",
    landmarks: [
      "Karelsbrug, Praag",
      "Praagse Burcht",
      "Ossuarium van Sedlec",
      "Karlovy Vary",
    ],
  },
  cy: {
    description:
      "Cyprus is een legendarisch eiland in de Middellandse Zee, de geboorteplaats van Aphrodite, en combineert ongerepte stranden met indrukwekkende oude ruïnes.",
    gastronomy: "Halloumi, souvla, sheftalia, moussaka.",
    landmarks: [
      "Archeologisch park van Paphos",
      "De Rots van Aphrodite",
      "Troodos-gebergte",
    ],
  },
  ie: {
    description:
      "Ierland, het Emerald Isle, wordt bepaald door zijn winderige kliffen, warme Keltische muziek en gastvrije pubcultuur.",
    gastronomy: "Ierse stoofpot, Guinness, frisdrankbrood, colcannon.",
    landmarks: [
      "Kliffen van Moher",
      "Guinness-opslagplaats",
      "Ring van Kerry",
      "Drievuldigheidscollege",
    ],
  },
  lv: {
    description:
      "Letland betovert met zijn bruisende hoofdstad vol Art Nouveau-architectuur en kilometerslange ongerepte stranden aan de Baltische kust.",
    gastronomy: "Rupjmaize (donker roggebrood), grijze erwten met spek, sprot.",
    landmarks: [
      "De oude binnenstad van Riga",
      "Huis van de mee-eters",
      "Gauja Nationaal Park",
    ],
  },
  lt: {
    description:
      "Litouwen is de zuidelijkste Baltische parel, rijk aan gletsjermeren, dichte bossen en ontroerende getuigenissen van zijn tumultueuze verleden.",
    gastronomy:
      "Cepelinai (aardappelknoedels), koude borsjtsoep (šaltibarščiai).",
    landmarks: [
      "Kasteel Trakai-eiland",
      "Heuvel van kruisen",
      "De oude binnenstad van Vilnius",
    ],
  },
  mt: {
    description:
      "Malta combineert feilloos de warmte van de mediterrane zon en 7.000 jaar maritieme geschiedenis, tempeliersforten en turquoise lagunes.",
    gastronomy: "Pastizzi, konijnenstoofpot (Stuffat tal-fenek), ftira.",
    landmarks: [
      "St. John's Co-kathedraal",
      "Stad Mdina",
      "Blauwe Lagune (Comino)",
    ],
  },
  lu: {
    description:
      "Luxemburg is een welvarende groothertogelijke microstaat, waarvan de valleien vol staan ​​met middeleeuwse kastelen en de hoofdstad een spectaculaire citadel is.",
    gastronomy: "Judd mat Gaardebounen, Gromperekichelcher, Moezelwijnen.",
    landmarks: ["Chemin de la Corniche", "Bockkazematten", "Kasteel Vianden"],
  },
  pl: {
    description:
      "Polen is de culturele pijler van Oost-Europa, begiftigd met imposante gerestaureerde steden, het tragische Auschwitz-monument en het Tatragebergte.",
    gastronomy: "Pierogi, bigos, kielbasa, Poolse wodka.",
    landmarks: [
      "Marktplein van Krakau",
      "Wieliczka-zoutmijn",
      "Auschwitz-Birkenau",
      "Wawel-kasteel",
    ],
  },
  sk: {
    description:
      "Minder bekend: Slowakije is een bergachtige schat met het hoogste aantal kastelen per hoofd van de bevolking ter wereld, binnen de Hoge Tatra.",
    gastronomy: "Bryndzové halušky (gnocchi van schapenkaas), Kofola.",
    landmarks: ["Het kasteel van Bratislava", "Hoge Tatra", "Kasteel Spiš"],
  },
  si: {
    description:
      "Slovenië is een klein ecoparadijs met het mythische meer van Bled, kolossale karstgrotten en een uitzonderlijk groene hoofdstad.",
    gastronomy: "Kranjska klobasa, potica (notenrol), štrukli.",
    landmarks: [
      "Meer van Bled",
      "De Postojna-grot",
      "Het kasteel van Ljubljana",
      "Triglav Nationaal Park",
    ],
  },
  ro: {
    description:
      "Roemenië wordt gedomineerd door de legende van Dracula en herbergt de weelderige Karpaten, de majestueuze Donaudelta en levendige steden in Transsylvanië.",
    gastronomy: "Mici, sarmale, mămăligă, tuică.",
    landmarks: [
      "Kasteel Bran",
      "Kasteel Peleş",
      "Donaudelta",
      "Paleis van het Parlement",
    ],
  },
  se: {
    description:
      "Zweden belichaamt de Scandinavische stijl, verspreid over prachtige archipels, noorderlicht en een rijke traditie van strak design.",
    gastronomy:
      "Gehaktballetjes (Köttbullar), fika, gravlax zalm, surströmming haring.",
    landmarks: [
      "Vasa-museum",
      "Stad Visby",
      "Gamla Stan",
      "IJshotel Jukkasjärvi",
    ],
  },
  is: {
    description:
      "IJsland, het land van vuur en ijs, maakt indruk met zijn geisers, gigantische gletsjers, actieve vulkanen en melkachtige warmwaterbronnen.",
    gastronomy: "Hákarl (gefermenteerde haai), Skyr, IJslands lamsvlees.",
    landmarks: [
      "Blauwe Lagune",
      "Gouden Cirkel",
      "Gullfoss-waterval",
      "Het zwarte zandstrand van Reynisfjara",
    ],
  },
  no: {
    description:
      "Noorwegen biedt een van de mooiste geologische landschappen ter wereld: de majestueuze fjorden die de zee uitsnijden, omringd door steile bergen.",
    gastronomy: "Zalm, rakfisk, bruine kaas (Brunost), elandvlees.",
    landmarks: ["Geirangerfjord", "Noordkaap", "Lofoten-eilanden", "Bryggen"],
  },
  al: {
    description:
      "Albanië, voorheen hermetisch, is de geheime parel van de Middellandse Zee, boordevol kristalhelder blauw water, spectaculaire Alpen en Grieks-Romeinse ruïnes.",
    gastronomy: "Byrek, fëgesë, zeevruchten, baklava.",
    landmarks: ["Albanese Rivièra", "Berat", "Butrint Nationaal Park"],
  },
  ad: {
    description:
      "Dit kleine vorstendom, hoog in de Pyreneeën, is een waar toevluchtsoord voor liefhebbers van skiën en wilde natuur.",
    gastronomy: "Trinxat, escudella, bergcharcuterie.",
    landmarks: ["Madriu-Perafita-Claror-vallei", "Caldea", "Grandvalira"],
  },
  at: {
    description:
      "Oostenrijk is een bergland bij uitstek en schittert met zijn ongeëvenaarde klassieke muziek, keizerlijke paleizen en adembenemende berglandschappen.",
    gastronomy: "Wiener Schnitzel, Apfelstrudel, Sachertorte, Tafelspitz.",
    landmarks: ["Paleis Schönbrunn", "Hofburg", "Kitzbüheler Alpen"],
  },
  by: {
    description:
      "Wit-Rusland verrast met zijn ongerepte natuur, dichte ongerepte bossen (zoals Bialowieza) waar bizons leven, en middeleeuwse kastelen met een rijk verleden.",
    gastronomy: "Draniki (aardappelpannenkoekjes), machanka, kolduny.",
    landmarks: ["Mir-kasteel", "Nesvizh-paleis", "Het fort van Brest"],
  },
  ba: {
    description:
      "Een kruispunt van culturen in het hart van de Balkan, waar Oost en West elkaar ontmoeten. Je zult verliefd worden op de smaragdgroene rivieren, ruige bergen en de beroemde oude brug van Mostar.",
    gastronomy: "Ćevapi, burek, baklava, Bosnische koffie.",
    landmarks: [
      "Stari Most (oude brug)",
      "Baščaršija (Sarajevo)",
      "Kravica-watervallen",
    ],
  },
  me: {
    description:
      "Ondanks zijn kleine omvang verbergt Montenegro enkele van de mooiste landschappen van de Adriatische Zee. De baai van Kotor ontmoet spectaculaire donkere bergen (de 'zwarte bergen').",
    gastronomy:
      "Brav u Mlijeku (lamsvlees in melk), cevapi, gerookte Njeguši prosciutto.",
    landmarks: ["Baai van Kotor", "Durmitor Nationaal Park", "Sveti Stefan"],
  },
  az: {
    description:
      "Azerbeidzjan, het 'Land van Vuur', is een fascinerende mix van oud historisch erfgoed en glanzende ultramoderne infrastructuur aan de oevers van de Kaspische Zee.",
    gastronomy: "Plov, dolma, piti, qutab, baklava.",
    landmarks: [
      "Vlamtorens (Bakoe)",
      "Oude stad (Icherisheher)",
      "Gobustan moddervulkanen",
    ],
  },
  am: {
    description:
      "Armenië, een van 's werelds oudste christelijke naties, biedt spectaculaire berglandschappen en majestueuze stenen kloosters gelegen aan de rand van diepe kloven.",
    gastronomy: "Khorovats (Armeense barbecue), dolma, lavash, lahmajoun.",
    landmarks: ["Khor Virap-klooster", "Tempel van Garni", "Geghard-klooster"],
  },
  mc: {
    description:
      "Monaco is het toonbeeld van glamour aan de oevers van de Middellandse Zee, met luxe jachten, het wereldberoemde casino en de legendarische Formule 1 Grand Prix.",
    gastronomy: "Barbajuan, Monegaskische fougasse, stocafi.",
    landmarks: [
      "Casino van Monte Carlo",
      "De Rots van Monaco",
      "Prinselijk Paleis",
      "Haven Hercules",
    ],
  },
  li: {
    description:
      "Liechtenstein, een van de kleinste landen ter wereld, strekt zich uit tussen Zwitserland en Oostenrijk langs het Rijndal en wordt gedomineerd door zijn prachtige prinselijke kasteel en alpentoppen.",
    gastronomy: "Käsknöpfle (kaaspasta), Ribel.",
    landmarks: [
      "Vaduz-kasteel",
      "Museum voor Schone Kunsten (Kunstmuseum)",
      "Malbun-skiresort",
    ],
  },
  xk: {
    description:
      "Kosovo is een jonge Balkannatie, rijk aan geschiedenis en prachtige berglandschappen. Het valt op door goed bewaarde historische Ottomaanse pareltjes en een zeer gastvrije bevolking.",
    gastronomy: "Flija, burek, qebapa, Šar-kaas.",
    landmarks: ["Visoki Dečani-klooster", "Oude Prizren", "Rugova-kloof"],
  },
  ge: {
    description:
      "Georgië biedt grandioze natuur in de bergen van de Kaukasus, fascinerende oude architectuur en de reputatie de oudste wijnregio ter wereld te zijn.",
    gastronomy: "Khachapuri, khinkali (knoedels), churchkhela.",
    landmarks: [
      "Drievuldigheidskerk van Gergeti",
      "De oude binnenstad van Tbilisi",
      "Vardzia (grottenstad)",
    ],
  },
  md: {
    description:
      "Moldavië, de verborgen schat van Oost-Europa, trekt onvermijdelijk liefhebbers van wijntoerisme aan met zijn enorme ondergrondse kelders en voorouderlijke, uit de rotsen gehouwen kloosters.",
    gastronomy: "Mămăligă (polenta), plăcinte (gevulde gebakjes), sarmale.",
    landmarks: [
      "Orheiul Vechi (grottenklooster)",
      "Cricova-wijnhuizen",
      "Mileştii Mici-kelders",
    ],
  },
  fr: {
    description:
      "Frankrijk is 's werelds belangrijkste toeristische bestemming, bekend om zijn uitzonderlijke erfgoed, diverse landschappen, variërend van de Franse Rivièra tot de Alpentoppen, en een onvergelijkbare art de vivre.",
    gastronomy: "Stokbrood, kazen, wijn, croissants, bourguignon.",
    landmarks: [
      "Eiffeltoren, Parijs",
      "Mont Saint-Michel",
      "Kastelen in de Loire-vallei",
      "Franse Rivièra",
    ],
    overseas: [
      "Guadeloupe",
      "Martinique",
      "Frans-Guyana",
      "Bijeenkomst",
      "Mayotte",
      "Frans-Polynesië",
      "Nieuw-Caledonië",
    ],
  },
  es: {
    description:
      "Spanje fascineert met zijn zonnige klimaat, levendige cultuur van siësta tot flamenco, prachtige stranden en unieke historische architectuur, vooral het Moorse erfgoed.",
    gastronomy: "Tapas, paella, Iberische ham, gazpacho, sangria.",
    landmarks: [
      "Sagrada Família, Barcelona",
      "Alhambra, Granada",
      "Koninklijk Paleis van Madrid",
      "Plaza de España, Sevilla",
    ],
    overseas: ["Canarische Eilanden", "Balearen", "Ceuta", "Melilla"],
  },
  gb: {
    description:
      "Het Verenigd Koninkrijk biedt een unieke mix van monarchale traditie, culturele avant-garde, prachtige Schotse landschappen en historische steden.",
    gastronomy: "Fish and chips, rosbief, Yorkshire pudding, thee.",
    landmarks: [
      "Big Ben en Westminster Palace",
      "Steenhenge",
      "Toren van Londen",
      "Edinburgh kasteel",
    ],
    overseas: ["Bermuda", "Kaaimaneilanden", "Gibraltar"],
  },
  it: {
    description:
      "Italië is een openluchtmuseum. Tussen Romeinse ruïnes, de Florentijnse Renaissance, Venetiaanse kanalen en een pittoreske kustlijn biedt het land een onvergetelijke reis.",
    gastronomy: "Pasta, pizza, gelato, espresso, tiramisu.",
    landmarks: [
      "Colosseum, Rome",
      "Scheve Toren van Pisa",
      "Kathedraal van Florence",
      "Groot Kanaal, Venetië",
    ],
    overseas: ["Sardinië"],
  },
  pt: {
    description:
      "Portugal betovert met zijn kleurrijke straten, door de Atlantische Oceaan gewassen stranden en de uitzonderlijke gastvrijheid van de bevolking, op de meeslepende melodie van Fado.",
    gastronomy: "Pastéis de nata, bacalhau, Francesinha, Portwijn.",
    landmarks: [
      "Toren van Belém, Lissabon",
      "Ribeira, Porto",
      "Pena-paleis, Sintra",
      "Stranden van de Algarve",
    ],
    overseas: ["Madeira", "Azoren"],
  },
  gr: {
    description:
      "Griekenland, de bakermat van de westerse beschaving, nodigt je uit op een mythologische reis, van de Akropolis naar het sublieme kristalheldere water van de Cycladen.",
    gastronomy: "Moussaka, souvlaki, Griekse salade, tzatziki.",
    landmarks: [
      "Akropolis van Athene",
      "Santorini",
      "Meteora",
      "Knossos-paleis",
    ],
    overseas: ["Kreta", "Rhodos"],
  },
  dk: {
    description:
      "Denemarken vertegenwoordigt het concept van 'Hygge': een vredig Scandinavisch land, een pionier op het gebied van design, vol fietspaden en koninklijke paleizen.",
    gastronomy: "Smørrebrød, frikadeller, Wienerbrød, Carlsberg-bier.",
    landmarks: [
      "Tivoli-tuinen",
      "Nyhavn",
      "De kleine zeemeermin",
      "Kasteel Kronborg",
    ],
    overseas: ["Faeröer eilanden", "Groenland"],
  },
  rs: {
    description:
      "Servië combineert het bruisende nachtleven van Belgrado aan de Donau, het dramatische fort Petrovaradin en prachtige verborgen orthodoxe kloosters.",
    gastronomy: "Cevapi, pljeskavica, kajmak, rakija (fruitbrandewijn).",
    landmarks: [
      "Fort van Belgrado (Kalemegdan)",
      "Het Golubac-fort",
      "Tempel van Sint Sava",
    ],
  },
  nl: {
    description:
      "Nederland staat bekend om zijn vlakke landschappen, labyrintische grachten, tulpenvelden en iconische windmolens.",
    gastronomy: "Gouda, stroopwafel, rauwe haring, poffertjes.",
    landmarks: [
      "Amsterdamse grachten",
      "Keukenhof-tuinen",
      "Molens van Kinderdijk",
      "Van Goghmuseum",
    ],
    overseas: ["Aruba", "Curacao"],
  },
  sm: {
    description:
      "Gelegen op de berg Titano en volledig omgeven door Italië, claimt San Marino de titel van 's werelds oudste republiek en soevereine constitutionele staat.",
    gastronomy:
      "Torta Tre Monti (Drie Bergen Cake), piadina, bonen met varkenszwoerd.",
    landmarks: [
      "De drie torens (Guaita, Cesta, Montale)",
      "Basiliek van San Marino",
      "Piazza della Liberta",
    ],
  },
  mk: {
    description:
      "In het hart van de Balkan schittert Noord-Macedonië met het ongelooflijk heldere oude meer van Ohrid, zijn orthodoxe erfgoed en bewaarde nationale parken.",
    gastronomy: "Tavče gravče (gebakken bonen), ajvar, pastrmajlija.",
    landmarks: ["Meer van Ohrid", "Kerk van St. John in Kaneo", "Matka-kloof"],
  },
  va: {
    description:
      "Het Vaticaan, de kleinste soevereine staat ter wereld, bevindt zich in het hart van Rome en fungeert als de spirituele zetel van de katholieke kerk, waar wonderbaarlijke artistieke meesterwerken van Michelangelo te vinden zijn.",
    gastronomy:
      "Geen exclusieve keuken; biedt traditionele Romeinse gastronomie.",
    landmarks: ["Vaticaanse Musea"],
  },
};
